import { render, staticRenderFns } from "./BackerCenterPledgeCardHeader.vue?vue&type=template&id=2012e144"
import script from "./BackerCenterPledgeCardHeader.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgeCardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports